module.exports = __webpack_public_path__ + "static/media/cae-logo.c76eeacf.png";